import { render, staticRenderFns } from "./workout-description.component.vue?vue&type=template&id=17cbe0b8&scoped=true"
import script from "./workout-description.component.ts?vue&type=script&lang=ts&external"
export * from "./workout-description.component.ts?vue&type=script&lang=ts&external"
import style0 from "./workout-description.component.scss?vue&type=style&index=0&id=17cbe0b8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17cbe0b8",
  null
  
)

export default component.exports